import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { ToastrService } from 'ngx-toastr';
import { fromEvent, Observable, Subscription } from 'rxjs';
import { RootStoreState } from '@app/root-store';
import { vaultStoreActions } from '../../../../../root-store/index';
import { SharedVaultService } from '@app/shared/services/vault/shared-vault.service';
import { DiscoveryService } from '@app/shared/services/discovery/discovery.service';
import * as selectors from '../../../../../root-store/relationship-store/relationship.selector';
import * as loginSelectors from '../../../../../root-store/login-store/login.selector';
import * as vaultSelectors from '../../../../../root-store/vault-store/vault.selector';
import { AddVaultDialogComponent } from '@app/shared/component/add-vault-dialog/add-vault-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { Route, Router } from '@angular/router';

import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
  selector: 'add-vault',
  templateUrl: './add-vault.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DiscoveryVaultComponent implements OnInit, OnDestroy {
  @Input() data;
  @Input() fromVault = false;
  @Input() showBackButton = true;
  @Input() isLocationTitle = false;
  @Input() form_name = false;
  @Input() fromTemplateRegister = false;
  @Input() is_check_box_selection = false;

  selected_item;

  @Output() dVaultEmitter: EventEmitter<any> = new EventEmitter();
  @Output() detailsVaultEmitter: EventEmitter<any> = new EventEmitter();

  stateObject;
  screenWidth = 0;
  searchVault = '';
  // step = 0;
  // vaultType;
  // currentUser;
  // members = [];
  // vaultName = '';
  // selectedUsers = [];

  // stepOneCompleted = false;
  // stepTwoCompleted = false;
  // stepThreeCompleted = false;
  // allConnections: any = [];
  sharedVaultItems$;
  showFirstStep = false;
  showSecondStep = false;
  today = new Date();
  subscription = new Subscription();
  resizeObservable$: Observable<Event>;
  loaderItems = [{ id: 1 }, { id: 2 }, { id: 3 }, { id: 4 }, { id: 5 }, { id: 6 }];

  options = [
    { value: 'Yes', isSelected: false },
    { value: 'No', isSelected: false },
  ];
  vaultTypeOptions = [
    { displaytext: 'Personal Vault', value: 'personal', isSelected: false },
    { displaytext: 'Shared Vault', value: 'shared', isSelected: false },
    { displaytext: 'Holding Vault', value: 'holding', isSelected: false },
    { displaytext: 'Trust Vault', value: 'trust', isSelected: false },
    { displaytext: 'Operating Vault', value: 'operating', isSelected: false },
  ];

  constructor(
    private store: Store,
    private router: Router,
    private dialog: MatDialog,
    private sharedVaultService: SharedVaultService,
    private discoveryService: DiscoveryService,
    private store$: Store<RootStoreState.State>,
    private toastr: ToastrService,
    private cd: ChangeDetectorRef
  ) {
    this.subscription.add(
      this.store.pipe(select(loginSelectors.getCurrentUserFullDetails)).subscribe((result) => {
        if (result) {
          this.stateObject = result;
        } else {
          this.stateObject = null;
        }
      })
    );
  }

  ngOnInit(): void {
    this.screenWidth = window.innerWidth;
    this.resizeObservable$ = fromEvent(window, 'resize');
    this.subscription.add(
      this.resizeObservable$.subscribe((evt) => {
        this.screenWidth = evt.target['innerWidth'];
      })
    );

    this.showFirstStep = this.data?.action_type_config?.includes('check') || false;
    this.showSecondStep = !this.showFirstStep;

    if (!this.router.url.includes('workspace')) {
      if (!this.fromVault) this.store$.dispatch(new vaultStoreActions.GetVaultRequestAction(this.stateObject.id, true));
    }
    this.sharedVaultItems$ = this.store.pipe(select(vaultSelectors.getVaultItems('Last Updated')));
    // this.members = [{ user_id: this.stateObject?.id, type: 'owner' }];
    // this.getAndFilterAllUsers();
  }

  setDiscoverySetupVault(vault) {
    if (this.is_check_box_selection) {
      this.selected_item = vault;
      this.dVaultEmitter.emit(this.selected_item);
      return;
    }
    if (this.fromTemplateRegister) {
      this.detailsVaultEmitter.emit(vault);
    } else {
      const requestObject = {
        vault_user_form_id: this.data.vault_user_form_id,
        vault_id: vault.id,
      };
      this.subscription.add(
        this.discoveryService.setDiscoverySetupVault(requestObject).subscribe(
          (data) => {
            this.handleSteps('forward');
          },
          (error: any) => {
            this.toastr.error(error.error.message);
          }
        )
      );
    }
  }

  addNewVault() {
    const modalRef = this.dialog.open(AddVaultDialogComponent, {
      panelClass: 'full-window-dialog-2',
      disableClose: true,
      autoFocus: false,
      data: {
        user_id: this.stateObject?.id,
        fromDiscovery: true,
      },
    });
    this.subscription.add(
      modalRef.afterClosed().subscribe((res) => {
        if (!this.fromVault) this.store$.dispatch(new vaultStoreActions.GetVaultRequestAction(this.stateObject.id, true));
        if (this.fromTemplateRegister) {
          if (res.data) {
            this.selected_item = res.data;
            this.dVaultEmitter.emit(res.data);
          }
        } else {
          if (res.vault_id) {
            this.setDiscoverySetupVault(res.vault_id);
          }
        }
      })
    );
  }

  // getAndFilterAllUsers() {
  //   this.subscription.add(
  //     this.store$.pipe(select(selectors.getAndFilterAllUsers())).subscribe((res) => {
  //       const tempEllemt = res.map((element) => ({
  //         ...element,
  //         name: element?.user_first_name + ' ' + element?.user_last_name,
  //         isAccess: true,
  //         connection_status: 'approved',
  //         isSelected: false,
  //       }));
  //       this.allConnections = [
  //         {
  //           user_email: this.stateObject?.email,
  //           user_id: this.stateObject?.id,
  //           user_profile_image_url: this.stateObject?.profile_image_url,
  //           name: this.stateObject?.name,
  //           isSelected: true,
  //         },
  //         ...tempEllemt,
  //       ];
  //       this.cd.detectChanges();
  //     })
  //   );
  // }

  // createVault() {
  //   if (!this.vaultName && !this.vaultType) return;
  //   const payload = {
  //     name: this.vaultName ?? 'Untitled Vault',
  //     type: this.vaultType,
  //     user_id: this.data.user_id,
  //     member: this.members,
  //   };
  //   this.subscription.add(
  //     this.sharedVaultService.createVault(payload).subscribe(
  //       (data) => {
  //         if (data) {
  //           this.store$.dispatch(new vaultStoreActions.GetVaultRequestAction(this.data?.user_id, false));
  //           if (!this.fromVault) this.setDiscoverySetupVault(data.id);
  //           if (this.fromVault) this.dVaultEmitter.emit('vault created');
  //         }
  //       },
  //       (error: any) => {
  //         this.toastr.error(error.error.message);
  //       }
  //     )
  //   );
  // }

  // handleSelectedVaultType(item) {
  //   this.vaultTypeOptions.forEach((opt) => {
  //     opt.isSelected = false;
  //   });
  //   item['isSelected'] = !item.isSelected;
  //   this.vaultType = item.value;
  //   this.cd.detectChanges();
  // }

  // handleSelectedUser(user: any) {
  //   if (user.user_id != this.data?.user_id) user.isSelected = !user.isSelected;
  //   const userExists = this.members.some((obj) => obj.user_id === user.user_id);
  //   if (!user.isSelected && userExists) {
  //     const newArray = this.members.filter((obj) => obj.user_id !== user.user_id);
  //     this.members = [...newArray];
  //   }
  //   if (user.isSelected && !userExists) {
  //     this.members.push({
  //       user_id: user.user_id,
  //       type: 'member',
  //     });
  //   }
  // }

  // selectAllContent($event) {
  //   $event.target.select();
  // }

  // handleInput(event) {
  //   this.vaultName = event.target.value;
  // }

  // disableWhiteSpaceOnFirstCharacter(event) {
  //   if (event.target.selectionStart == 0 && (event.keyCode == 32 || event.keyCode == 9)) {
  //     event.preventDefault();
  //   }
  // }

  // connectionCreated(event) {
  //   const user = {
  //     user_id: event.id,
  //     user_profile_image_url: event.profile_image_url,
  //     name: event?.name,
  //   };
  //   this.handleSelectedUser(user);
  // }

  // moveToFormSection(direction) {
  //   if (direction == 'next') {
  //     this.showFirstStep = false;
  //     this.showSecondStep = true;
  //   }
  //   if (direction == 'back') {
  //     this.showFirstStep = true;
  //     this.showSecondStep = false;
  //   }
  // }

  // nextStep() {
  //   if (this.step == 0) {
  //     this.stepOneCompleted = this.vaultType ? true : false;
  //   } else if (this.step == 1) {
  //     this.stepTwoCompleted = this.vaultName ? true : false;
  //   } else if (this.step == 2) {
  //     this.stepThreeCompleted = true;
  //   }
  //   this.step++;
  // }

  // prevStep() {
  //   this.step--;
  // }

  // setStep(index: number) {
  //   this.step = index;
  // }

  handleSteps(event) {
    if (event === 'Yes') {
      this.addNewVault();
    } else if (event === 'No') {
      this.showFirstStep = false;
      this.showSecondStep = true;
    } else {
      this.dVaultEmitter.emit({ status: event, id: this.data?.id });
    }
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
